import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';

@Component({
  selector: 'app-score-generate-modal',
  templateUrl: './score-generate-modal.component.html',
  styleUrls: ['./score-generate-modal.component.css'],
})
export class ScoreGenerateModalComponent implements OnInit {
  // Define the API endpoint for score generation
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ScoreGenerateModalComponent>
  ) {}
  // API endpoint for score generation
  ngOnInit(): void {
    this.timeout = setInterval(() => {
      this.progress();
    }, 80);
  }
  // API endpoint for score generation
  timeout: any;
  value: number = 0;
  progress() {
    if (this.value < 100) {
      this.value++;
    } else {
      clearInterval(this.timeout);
      this.dialogRef.close();
    }
  }
}
